import styled from 'styled-components'
import { Button } from 'antd'

const Btn = (props) => {
  const onClick = () => {
    let { name, onClick } = props
    if (onClick) onClick(name)
  }

  let { disabled, children, text, loading } = props

  let click
  if (!loading && !disabled) {
    click = onClick
  }
  return (
    <PageView>
      <Button disabled={disabled} loading={loading} onClick={click}>
        {children || text}
      </Button>
    </PageView>
  )
}

const PageView = styled.div`
  button {
    color: white;
    background-color: ${(p) => p.theme.color.red};
    width: 100%;
    height: 50px;
    font-size: 14px;
    font-weight: 700;
    border-radius: 14px;
    border: 0px;
  }

  button:hover,
  button:focus,
  button:active {
    color: white;
    background-color: ${(p) => p.theme.color.red};
  }
`

export default Btn
